import { CheckboxLarge, StyledCheckbox } from "../../";
import styled from "styled-components";
export const ResponsiveCheckbox = styled(CheckboxLarge)`
  @media not screen and ${props => props.theme.media.large} {
    padding: 0;
    ${StyledCheckbox} {
      display: none;
    }
  }
`;